var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"content__title"},[_vm._v("Racing season 2024")]),_c('my-countdown',{attrs:{"dark":""}}),_c('div',{staticClass:"races"},_vm._l((_vm.tracks),function(item,index){return _c('race-item',{key:index,attrs:{"item":item,"index":index + 1,"points":_vm.points,"results":_vm.results}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }